import { useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { Outlet } from "react-router-dom";
import type { ShippingLabelFormValues } from "../types/forms";
import { useShippingRates } from "../hooks/useShippingRates";
import { ShippingLabelContext } from "../hooks/useShippingLabelContext";

export const ShippingLabelProvider = () => {
  const methods = useForm<ShippingLabelFormValues>();
  const ratesQuery = useShippingRates();
  const [calculatedInputs, setCalculatedInputs] = useState<string | null>(null);

  return (
    <FormProvider {...methods}>
      <ShippingLabelContext.Provider
        value={{ ratesQuery, calculatedInputs, setCalculatedInputs }}
      >
        <Outlet />
      </ShippingLabelContext.Provider>
    </FormProvider>
  );
};
